import { empApi } from "./client";

// =============================================================
// API chữ kí số - proxy qua backend-v1 (/signature), khớp app mobile-app-v2
// (src/modules/signature/signature.api.ts).
// =============================================================

// Danh sách chữ kí của nhân viên đang đăng nhập
// params: { page, limit, status, sourceType, search }
export const getSignatureListApi = (params) => empApi.get("/signature", params);

// Tạo chữ kí mới: { title, status, sourceType, signatureImageBase64 }
export const createSignatureApi = (body) => empApi.post("/signature", body);

// Xóa chữ kí
export const deleteSignatureApi = (id) => empApi.del(`/signature/${id}`);

// Kí nháp: tải file docx mẫu (đã chèn chữ kí) về máy
export const downloadDraftSignatureApi = async (id) => {
  const res = await empApi.raw.get(`/signature/test/${id}`, {
    responseType: "blob",
  });
  return res?.data;
};
